import { css } from "@linaria/core";

export const nutritionTitle = css`
  line-height: var(--ant-control-height);
  margin: 0;
`;

export const subItem = css`
  padding-left: var(--ant-padding-sm);
`;
